import { defineStore } from 'pinia'
import * as Api from './api'

type MaintenanceMode =
  | 'idle'
  | 'checking'
  | 'maintenance'
  | 'service-unavailable'
  | 'resolved'

type State = {
  mode: MaintenanceMode
}

const getDefaultState = (): State => ({
  mode: 'idle',
})

export const useMaintenanceStore = defineStore('maintenance', {
  state: getDefaultState,

  getters: {
    isVisible: (state) => state.mode !== 'idle' && state.mode !== 'checking',
    blocksApplication: (state) => state.mode === 'maintenance',
    isRecovered: (state) => state.mode === 'resolved',
  },

  actions: {
    async loadMaintenanceStatus() {
      if (this.mode !== 'idle') {
        return
      }

      this.mode = 'checking'

      const result = await Api.pollMaintenanceUntilResolvedOrError(
        () => (this.mode = 'maintenance')
      )

      if (result.status === 'error' || this.mode === 'checking') {
        this.mode = 'service-unavailable'
      } else {
        this.mode = 'resolved'
      }
    },

    close() {
      if (this.mode === 'service-unavailable' || this.mode === 'resolved') {
        this.mode = 'idle'
      }
    },
  },
})
